import React from 'react';
import { AIcon } from '../../atoms/AIcon/index';
import { AIconSize } from '../../atoms/AIcon/AIcon.types';
import * as Styled from './MControlTabScroll.styles';
import { MControlTabScrollDirection, type MControlTabScrollProps } from './MControlTabScroll.types';

const COMPONENT_NAME = 'm-web-ui-kit-MControlTabScroll';
const TEST_ID = 'web-ui-kit-MControlTabScroll';

function MControlTabScroll({
  direction = MControlTabScrollDirection.Right,
  className,
  'aria-label': providedAriaLabel,
  'aria-labelledby': ariaLabelledBy,
  ...rest
}: MControlTabScrollProps) {
  const ariaLabel =
    providedAriaLabel ??
    (ariaLabelledBy ? undefined : direction === MControlTabScrollDirection.Left ? 'Previous tabs' : 'Next tabs');

  return (
    <Styled.Wrapper
      data-component-name={COMPONENT_NAME}
      data-testid={TEST_ID}
      $direction={direction}
      className={className}
      {...rest}
      type="button"
      aria-label={ariaLabel}
      {...(ariaLabelledBy && { 'aria-labelledby': ariaLabelledBy })}
    >
      <Styled.IconWrapper $direction={direction}>
        <AIcon icon="icon-arrow-right" size={AIconSize.L} aria-hidden="true" />
      </Styled.IconWrapper>
    </Styled.Wrapper>
  );
}

export { MControlTabScroll, MControlTabScrollDirection, TEST_ID as M_CONTROL_TAB_SCROLL_TEST_ID };
export type { MControlTabScrollProps } from './MControlTabScroll.types';
